<template>
  <!-- 图表选择列表弹窗 -->
  <div class="chartListTip">
    <div class="tip-title">
      {{ chartName }}
    </div>
    <el-radio-group v-model="radio"  @change="changeFn">
      <el-radio  v-for="(item, i) in chartData" :key="i" :label="item">
        {{ item }}
      </el-radio>
    </el-radio-group>
  </div>
</template>
<script>
import { chartUpdate } from "@/assets/api/chartData";
export default {
   props: ["chartInfo"],
  data() {
    return {
      radio: 0,
      chartData: ["柱线图", "线型图", "雷达图", "仪表盘", "双线图", "柱状图"],
      chartName: "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.radio = this.chartInfo.chartNumber;
      this.chartName = this.chartInfo.filedName;
      if (this.chartInfo.filedKey=="powderWeight"||this.chartInfo.filedKey=="liquidInputWeight"||this.chartInfo.filedKey=="revolutionSpeed"
      ||this.chartInfo.filedKey=="coatingLength"||this.chartInfo.filedKey=="A layerTemperature"||this.chartInfo.filedKey=="A layerVacuumValue"
      ||this.chartInfo.filedKey=="weighBeforeFilling"||this.chartInfo.filedKey=="upperSealingKnifeTemperature"
      ||this.chartInfo.filedKey=="DFSFDWD"||this.chartInfo.filedKey=="DFXFDWD"
      ||this.chartInfo.filedKey=="CFSFDWD"||this.chartInfo.filedKey=="CFXFDWD"
      ) {
        this.chartData = ["柱线图","双线图"];
      }else if(this.chartInfo.filedKey=="flowmeter"||this.chartInfo.filedKey=="negativePressureFanSpeed"||this.chartInfo.filedKey=="capacityEfficiency"
      ||this.chartInfo.filedKey=="stirringTemperature"||this.chartInfo.filedKey=="vacuumValue"||this.chartInfo.filedKey=="stirringFrequency"
      ||this.chartInfo.filedKey=="stirAtMaximumSpeed"||this.chartInfo.filedKey=="AutoRunninSpeed"||this.chartInfo.filedKey=="ccrewPumpSpeed"
      ||this.chartInfo.filedKey=="ovenTemperature"||this.chartInfo.filedKey=="unwindingTension"||this.chartInfo.filedKey=="leftRollerGap"
      ||this.chartInfo.filedKey=="leftRollerGap"||this.chartInfo.filedKey=="data1"||this.chartInfo.filedKey=="operatingSpeed"
      ||this.chartInfo.filedKey=="data2"||this.chartInfo.filedKey=="poleWidth"||this.chartInfo.filedKey=="finalWeldingCooling"
      ||this.chartInfo.filedKey=="rewindingTension"||this.chartInfo.filedKey=="stampingSpeed"||this.chartInfo.filedKey=="tractionSpeed"
      ||this.chartInfo.filedKey=="robotSpeed"||this.chartInfo.filedKey=="data3"||this.chartInfo.filedKey=="pre-solderingTime"||this.chartInfo.filedKey=="ultrasonicFrequency"
      ||this.chartInfo.filedKey=="vacuumPumpAirPressure"||this.chartInfo.filedKey=="lowerHoldingPressureLimit"
      ||this.chartInfo.filedKey=="savalValue"||this.chartInfo.filedKey=="restTime"||this.chartInfo.filedKey=="vacuumValue"
      ||this.chartInfo.filedKey=="sealingTime"||this.chartInfo.filedKey=="numberOfSeals"||this.chartInfo.filedKey=="coreHeight"||this.chartInfo.filedKey=="windingSpeed"
      ||this.chartInfo.filedKey=="dustRemovalWindSpeed"||this.chartInfo.filedKey=="resistanceSetting"||this.chartInfo.filedKey=="ZJJPZL"
      ||this.chartInfo.filedKey=="FJJPZL"||this.chartInfo.filedKey=="pre-solderingCooling"||this.chartInfo.filedKey=="finalWeldingTime"||this.chartInfo.filedKey=="DFFKSJ"
      ||this.chartInfo.filedKey=="temperature" ||this.chartInfo.filedKey=="vacuum"
      ){
        this.chartData = ["线型图","柱状图"];
      }else if(this.chartInfo.filedKey=="deviceStatus"){
        this.chartData = ["雷达图"];
      }else if(this.chartInfo.filedKey=="hydraulicPressure"||this.chartInfo.filedKey=="Productivity"||this.chartInfo.filedKey=="equipmentEfficiency"
      ||this.chartInfo.filedKey=="pre-solderingPower"||this.chartInfo.filedKey=="voltage"||this.chartInfo.filedKey=="finalWeldingPower"
      ||this.chartInfo.filedKey=="capacityEfficiency"||this.chartInfo.filedKey=="SVXL"||this.chartInfo.filedKey=="currentEfficiency"
      ){
        this.chartData= ["仪表盘"];
      }
      
    });
  },
  methods: {
   async changeFn(e) {
      if(e=="柱线图"){
        this.chartInfo.chartNumber = 0;
      }else if(e=="线型图"){
        this.chartInfo.chartNumber = 1;
      }else if(e=="雷达图"){
        this.chartInfo.chartNumber = 2;
      }else if(e=="仪表盘"){
        this.chartInfo.chartNumber = 3;
      }else if(e=="双线图"){
        this.chartInfo.chartNumber = 4;
      }else if(e=="柱状图"){
        this.chartInfo.chartNumber = 5;
      }
     let res = await chartUpdate([this.chartInfo]);
     if (res.code == 200) {
        this.$message.success("修改成功");
      } else if (res.data.code == 405) {
        this.$message.error(res.data.msg);
      } else {
        this.$message.error("修改失败,请重试");
      }
    }
  },
};
</script>
<style lang="less" scoped>
.chartListTip {
  width: 200px;
  height: 230px;
  background: url("./images/machineListTip-bg.png") no-repeat 0 0;
  background-size: 100% 100%;

  .tip-title {
    width: 100%;
    height: 32px;
    padding: 0 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: url("./images/machineListTip-title.png") no-repeat 0 0;
    background-size: 100%;
    border: 1px solid;
    border-image: linear-gradient(
        243deg,
        rgba(223, 242, 255, 0),
        rgba(255, 255, 255, 1)
      )
      1 1;
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
  }
}
</style>

<style lang="less">
.chartListTip {
  .el-radio-group {
    height: calc(100% - 36px);
    padding-top: 14px;
    padding-left: 12px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: left;
    line-height: 28px;

    .el-radio {
      line-height: 1.8;

      .el-radio__input {
        width: 16px;
        height: 16px;
        .el-radio__inner {
          width: 100%;
          height: 100%;
          border-radius: 3px;
          border: 1px solid #32c5ff;
          background: rgba(0, 0, 0, 0);
        }
      }

      .is-checked {
        .el-radio__inner {
          border-radius: 3px;
          border: 1px solid #32c5ff;
          background: #32c5ff;
        }

        .el-radio__inner::after {
          content: "";
          width: 6px;
          height: 3px;
          border: 1.5px solid white;
          border-top: transparent;
          border-right: transparent;
          text-align: center;
          display: block;
          position: absolute;
          top: 4px;
          left: 4px;
          // vertical-align: middle;
          transform: rotate(-45deg);
          border-radius: 0;
          background: none;
        }
      }

      .el-radio__label {
        font-size: 12px;
        font-weight: 600;
        color: #ffffff;
      }
    }
  }
}
</style>